define('collections/users',['require','collections/base','models/user'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/user");

    return BaseCollection.extend({
        model: Model,
        url: 'users.json'
    });
});

